module.exports = __webpack_public_path__ + "img/scales_logo.f70e0ef9.png";